// src/WebServer/OncoRisk/content/modules/analysistools/multi-variant-search.js

// Keep existing imports
import React, { useState, useCallback } from 'react';
import './SingularNetwork.css';

function SingularNetwork() {

  return (
    <div className="OCRASN">
        <div className="OCRASN-top">
            <input
            placeholder="Search for variant..."
            
            className="OCRASN-search">
            
            </input>
            

        </div>
        <div className="OCRASN-bottom"></div>

    </div>
  );
}

export default SingularNetwork;